module.exports = __webpack_public_path__ + "img/tipocontacto012.7ce8cf4.svg";